export const RESET = 'CLIENT_LIST_RESET'
export const SET_ITEMS = 'CLIENT_LIST_SET_ITEMS'
export const SET_ERROR = 'CLIENT_LIST_SET_ERROR'
export const SET_VIEW = 'CLIENT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'CLIENT_LIST_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/client/list/mutation_types.js